import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceDetailComponent } from './invoice-detail.component';
import { CustomMaterialModule } from '@sk/custom-material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { NgxMaskModule } from 'ngx-mask';
import { TruncationPipeModule } from 'shared/pipes/truncationPipe/truncationPipe.module';
import { DefaultCurrencyPipeModule } from 'shared/pipes/defaultCurrencyPipe/defaultCurrencyPipe.module';
import { InvoiceItemEditDialogV2Module } from './invoiceitem-edit-dialog-v2/invoiceitem-edit-dialog-v2.module';

@NgModule({
  declarations: [ InvoiceDetailComponent ],
  imports: [
    CommonModule,
    CustomMaterialModule,
    NgxMaskModule.forRoot(),
    FlexLayoutModule,
    InvoiceItemEditDialogV2Module,
    RouterModule,
    TruncationPipeModule,
    DefaultCurrencyPipeModule
  ],
  providers: [],
  exports: [ InvoiceDetailComponent ]
})
export class InvoiceDetailModule {
}
